(function () {
  // Meta pixel is initialized globally by snippets/datalayer-user.liquid

  const form = document.getElementById('activate-pet-card-form');
  if (!form) return;

  const endpoint = form.dataset.endpoint;
  const customerId = form.dataset.customerId || null;
  const source = form.dataset.source;
  const submitBtn = document.querySelector('.activate-pet-card-submit');
  const errorContainer = form.querySelector('.activate-pet-card-error');
  const sectionWrapper = form.closest('.activate-pet-card__inner');

  var requiredFields = form.querySelectorAll('[name="first_name"], [name="last_name"], [name="email"], [name="clinic_name"], [name="pet_name"]');
  var permissionCheckbox = form.querySelector('[name="permission_to_contact"]');
  var consentCheckbox = form.querySelector('[name="marketing_consent"]');

  function updateButtonState() {
    var allFilled = Array.prototype.every.call(requiredFields, function (input) {
      return input.value.trim() !== '';
    });
    var consentOk = !consentCheckbox || consentCheckbox.checked;
    if (allFilled && permissionCheckbox.checked && consentOk) {
      submitBtn.classList.add('is-active');
      submitBtn.disabled = false;
    } else {
      submitBtn.classList.remove('is-active');
      submitBtn.disabled = true;
    }
  }

  requiredFields.forEach(function (input) {
    input.addEventListener('input', updateButtonState);
  });

  permissionCheckbox.addEventListener('change', updateButtonState);
  if (consentCheckbox) {
    consentCheckbox.addEventListener('change', updateButtonState);
  }

  updateButtonState();

  function showError(message) {
    if (errorContainer) {
      errorContainer.textContent = message;
      errorContainer.classList.add('visible');
    }
  }

  function hideError() {
    if (errorContainer) {
      errorContainer.textContent = '';
      errorContainer.classList.remove('visible');
    }
  }

  function showFieldError(input, message) {
    input.classList.add('invalid');
    const errorEl = input.parentElement.querySelector('.field-error');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.classList.add('visible');
    }
  }

  function clearFieldErrors() {
    form.querySelectorAll('input.invalid').forEach(function (input) {
      input.classList.remove('invalid');
    });
    form.querySelectorAll('.field-error.visible').forEach(function (el) {
      el.textContent = '';
      el.classList.remove('visible');
    });
  }

  function validateForm() {
    clearFieldErrors();
    var valid = true;

    var firstName = form.querySelector('[name="first_name"]');
    var lastName = form.querySelector('[name="last_name"]');
    var email = form.querySelector('[name="email"]');
    var petName = form.querySelector('[name="pet_name"]');

    if (!firstName.value.trim()) {
      showFieldError(firstName, 'Vyplňte jméno');
      valid = false;
    }
    if (!lastName.value.trim()) {
      showFieldError(lastName, 'Vyplňte příjmení');
      valid = false;
    }
    if (!email.value.trim()) {
      showFieldError(email, 'Vyplňte email');
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      showFieldError(email, 'Neplatný email');
      valid = false;
    }
    var clinicName = form.querySelector('[name="clinic_name"]');
    if (!clinicName.value.trim()) {
      showFieldError(clinicName, 'Vyplňte název kliniky');
      valid = false;
    }
    if (!petName.value.trim()) {
      showFieldError(petName, 'Vyplňte jméno mazlíčka');
      valid = false;
    }

    return valid;
  }

  function scrollToSection() {
    var section = sectionWrapper.closest('.activate-pet-card');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function showLoading() {
    var loadingHtml =
      '<div class="activate-pet-card-loading">' +
      '<svg class="activate-pet-card-loading__spinner" viewBox="0 0 56 56">' +
      '<circle cx="28" cy="28" r="22"/>' +
      '</svg>' +
      '<h2>Hledáme kliniku a mazlíčka...</h2>' +
      '<p>Chvilku prosím, zpřístupňujeme zdravotní kartičku</p>' +
      '</div>';

    if (sectionWrapper) {
      sectionWrapper.innerHTML = loadingHtml;
      scrollToSection();
    }
  }

  function showSuccess() {
    var successHtml =
      '<div class="activate-pet-card-success">' +
      '<div class="activate-pet-card-success__icon">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">' +
      '<path d="M6.5 11L9.5 14L15.5 8M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="#328E42" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</div>' +
      '<h2>Děkujeme!</h2>' +
      '<p>Kliniku kontaktujeme, aby propojila Váš účet na<br>VETSTOR s kartou mazlíčka kliniky.</p>' +
      '<div class="activate-pet-card-success__badge">' +
      '<span class="activate-pet-card-success__badge-dot"></span>' +
      '<span>Čeká na potvrzení kliniky</span>' +
      '</div>' +
      '</div>';

    if (sectionWrapper) {
      sectionWrapper.innerHTML = successHtml;
      scrollToSection();
    }
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    hideError();

    if (!validateForm()) return;

    var payload = {
      customer_id: customerId || null,
      first_name: form.querySelector('[name="first_name"]').value.trim(),
      last_name: form.querySelector('[name="last_name"]').value.trim(),
      email: form.querySelector('[name="email"]').value.trim(),
      phone: form.querySelector('[name="phone"]').value.trim() || null,
      clinic_name: form.querySelector('[name="clinic_name"]').value.trim(),
      pet_name: form.querySelector('[name="pet_name"]').value.trim(),
      clinic_source: source,
      clinic_type: 'USER_INPUTTED_CLINIC',
      permission_to_contact: permissionCheckbox.checked,
    };
    if (consentCheckbox) {
      payload.marketing_consent = consentCheckbox.checked;
    }

    submitBtn.classList.add('is-loading');
    submitBtn.textContent = 'Odesílám...';

    try {
      var response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        var errorText = await response.text();
        console.error('Submission failed:', response.status, errorText);
        showError('Odeslání se nezdařilo. Zkuste to prosím znovu.');
        submitBtn.classList.remove('is-loading');
        submitBtn.textContent = 'Aktivovat kartu';
        updateButtonState();
        return;
      }

      if (window.fbq) {
        window.fbq('init', '4276766762645430', {
          em: payload.email,
          fn: payload.first_name,
          ln: payload.last_name,
          ph: payload.phone || ''
        });
        if (source === 'IPHONE_COMPETITION') {
          window.fbq('trackCustom', 'b2c_form_submit_iphone', {
            content_name: 'IPhone form submit',
            content_category: 'iphone_form_submit'
          });
        } else {
          window.fbq('trackCustom', 'b2c_form_submit', {
            content_name: 'Aktivace karty mazlíčka',
            content_category: 'clinic_activation'
          });
        }
      }

      showLoading();
      setTimeout(showSuccess, 3000);
    } catch (err) {
      console.error('Network error:', err);
      showError('Chyba připojení. Zkuste to prosím znovu.');
      submitBtn.disabled = false;
      submitBtn.classList.remove('is-loading');
      submitBtn.textContent = 'Aktivovat kartu';
    }
  });
})();
